module.exports = __webpack_public_path__ + "img/logo-blue.4f50b2b5.svg";